<template>
  <IonToolbar color="white" class="border-b-2 border-gray-300">
    <HeaderBackButton @click.stop="goToDashboard">Dashboard</HeaderBackButton>
    <div>
      <div class="text-2xl text-gray-900 font-bold">
        {{ propertyStore.property?.name }}
      </div>
      <div class="flex items-center">
        <div class="text-xs text-gray-500 font-bold uppercase">
          {{ propertyStore.property?.address?.fullAddress }}
        </div>
        <BaseClearButton
          :disabled="!canGetDirections"
          @click.stop="openDirections()"
          class="text-nowrap my-0"
          size="small"
        >
          <i class="icon-car mr-1"></i>Directions
        </BaseClearButton>
      </div>
    </div>
  </IonToolbar>
</template>

<script setup lang="ts">
import BaseClearButton from '@/components/forms/BaseClearButton.vue';
import HeaderBackButton from '@/components/forms/HeaderBackButton.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { IonToolbar, isPlatform, useIonRouter } from '@ionic/vue';
import { computed } from 'vue';

const propertyStore = useSelectedProperty();
const router = useIonRouter();
const canGetDirections = computed(() => !!propertyStore.property?.address?.fullAddress);

async function openDirections() {
  if (propertyStore.property?.address?.fullAddress) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    if (isPlatform('ios')) {
      link.setAttribute('href', `http://maps.apple.com/?q=${propertyStore.property.address.fullAddress}`);
    } else {
      link.setAttribute('href', `https://maps.google.com/?q=${propertyStore.property.address.fullAddress}`);
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

function goToDashboard() {
  return router.navigate({ path: '/' }, 'back', 'push');
}
</script>

<style scoped></style>
